import React, { useState, useEffect } from 'react';
import { portfolioData } from '../data/portfolioData';
import Navigation from './Navigation';
import { useColorTheme } from '../hooks/useColorTheme';

function Contacts() {
  const [isMobile, setIsMobile] = useState(false);
  // 테마는 모든 페이지가 함께 쓰고 기억한다(페이지를 옮겨도 유지, CLAUDE.md Phase 22)
  const { colorTheme, systemDarkMode, currentTheme, toggleColorTheme } = useColorTheme();

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 640);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  return (
    <>
      <Navigation
        navigation={portfolioData.navigation}
        isMobile={isMobile}
        personal={portfolioData.personal}
        colorTheme={colorTheme}
        currentTheme={currentTheme}
        systemDarkMode={systemDarkMode}
        toggleColorTheme={toggleColorTheme}
      />

      {/* 데스크탑: 오른쪽 고정 사이드바 폭(--desktop-nav-width)만큼 본문을 비워 겹치지 않게 한다 (Phase 7) */}
      <section
        id="contacts"
        className={`min-h-screen px-4 ${isMobile ? 'pb-20' : ''} ${
          currentTheme === 'dark'
            ? 'bg-gray-900 text-white'
            : 'bg-orange-50 text-gray-900'
        }`}
        style={isMobile ? undefined : { paddingRight: 'calc(1rem + var(--desktop-nav-width))' }}
      >
        {/* 타이틀 띠 - 데스크탑에서는 사이드바를 뺀 본문 폭 기준으로 중앙.
            화면 맨 위 48px 를 페이지 배경색으로 덮어, 스크롤되는 본문이 제목 밑으로 비쳐 겹쳐 보이지 않게 한다.
            z-30: 본문 위, 메뉴 backdrop(z-40·60·95) 아래라 메뉴를 열면 함께 어두워진다 (CLAUDE.md Phase 14) */}
        <div
          className={`fixed top-0 left-0 right-0 z-30 h-12 flex items-center justify-center border-b ${
            currentTheme === 'dark' ? 'bg-gray-900 border-gray-800' : 'bg-orange-50 border-orange-100'
          }`}
          style={isMobile ? undefined : { right: 'var(--desktop-nav-width)' }}
        >
          <h2 className="text-xl font-bold">Contacts</h2>
        </div>

        <div className="container mx-auto max-w-4xl pt-16 flex justify-center">
          {/* Gravatar Hovercard */}
          <div className="gravatar-hovercard mt-4">
            <div className={`gravatar-hovercard__inner rounded-2xl shadow-2xl overflow-hidden max-w-md w-full ${
              currentTheme === 'dark' ? 'bg-gray-800' : 'bg-white'
            }`}>
              {/* Header Image */}
              <div className="gravatar-hovercard__header-image h-32 overflow-hidden">
                <img
                  className="gravatar-hovercard__header-image-img w-full h-full object-cover"
                  src="https://1.gravatar.com/avatar/bbfb5d8c5f3c492b56d65d34ab7958869bd704df7af1d1dfc8637bed20d7b36b?s=256&d=initials"
                  alt=""
                />
              </div>

              {/* Header with Avatar */}
              <div className="gravatar-hovercard__header relative px-6 pb-6">
                <a
                  className="gravatar-hovercard__avatar-link block -mt-16 mb-4"
                  href="https://snowycommander.link?utm_source=hovercard"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="gravatar-hovercard__avatar rounded-full border-4 border-white shadow-lg"
                    src="https://1.gravatar.com/avatar/bbfb5d8c5f3c492b56d65d34ab7958869bd704df7af1d1dfc8637bed20d7b36b?s=256&d=initials"
                    width="104"
                    height="104"
                    alt="snowycommander"
                  />
                </a>
                <a
                  className="gravatar-hovercard__personal-info-link block text-center"
                  href="https://snowycommander.link?utm_source=hovercard"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h4 className={`gravatar-hovercard__name text-2xl font-bold mb-2 ${
                    currentTheme === 'dark' ? 'text-white' : 'text-gray-900'
                  }`}>
                    snowycommander
                  </h4>
                  <p className={`gravatar-hovercard__job text-sm mb-1 ${
                    currentTheme === 'dark' ? 'text-gray-300' : 'text-gray-700'
                  }`}>
                    Coder, POCU Academy &amp; KNOU
                  </p>
                  <p className={`gravatar-hovercard__location text-sm ${
                    currentTheme === 'dark' ? 'text-gray-400' : 'text-gray-600'
                  }`}>
                    Daegu
                  </p>
                </a>
              </div>

              {/* Body */}
              <div className="gravatar-hovercard__body px-6 pb-4">
                <p className={`gravatar-hovercard__description text-center ${
                  currentTheme === 'dark' ? 'text-gray-300' : 'text-gray-700'
                }`}>
                  Undergraduate
                </p>
              </div>

              {/* Social Links */}
              <div className="gravatar-hovercard__social-links flex justify-center gap-4 px-6 pb-6">
                <a
                  className="gravatar-hovercard__social-link hover:opacity-70 transition-opacity"
                  href="https://snowycommander.link?utm_source=hovercard"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-service-name="gravatar"
                >
                  <img
                    className="gravatar-hovercard__social-icon"
                    src="https://s.gravatar.com/icons/gravatar.svg"
                    width="32"
                    height="32"
                    alt="Gravatar"
                  />
                </a>

                <a
                  className="gravatar-hovercard__social-link hover:opacity-70 transition-opacity"
                  href="https://github.com/SnowyCommander"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-service-name="github"
                >
                  <img
                    className="gravatar-hovercard__social-icon"
                    src="https://s.gravatar.com/icons/github.svg"
                    width="32"
                    height="32"
                    alt="GitHub"
                  />
                </a>

                <a
                  className="gravatar-hovercard__social-link hover:opacity-70 transition-opacity"
                  href="https://t.me/snowycommander"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-service-name="telegram"
                >
                  <img
                    className="gravatar-hovercard__social-icon"
                    src="https://s.gravatar.com/icons/telegram.svg"
                    width="32"
                    height="32"
                    alt="Telegram"
                  />
                </a>

                <a
                  className="gravatar-hovercard__social-link hover:opacity-70 transition-opacity"
                  href="https://calendly.com/gouahra"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-service-name="calendly"
                >
                  <img
                    className="gravatar-hovercard__social-icon"
                    src="https://s.gravatar.com/icons/calendly.svg"
                    width="32"
                    height="32"
                    alt="Calendly"
                  />
                </a>
              </div>

              {/* Footer */}
              <div className={`gravatar-hovercard__footer px-6 py-4 border-t ${
                currentTheme === 'dark' ? 'border-gray-700 bg-gray-800/50' : 'border-gray-200 bg-gray-50'
              }`}>
                <a
                  className={`gravatar-hovercard__profile-url block text-sm mb-2 truncate ${
                    currentTheme === 'dark' ? 'text-blue-400 hover:text-blue-300' : 'text-blue-600 hover:text-blue-500'
                  }`}
                  title="https://snowycommander.link"
                  href="https://snowycommander.link/?utm_source=profile-card"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  snowycommander.link
                </a>
                <a
                  className={`gravatar-hovercard__profile-link block text-sm font-medium ${
                    currentTheme === 'dark' ? 'text-blue-400 hover:text-blue-300' : 'text-blue-600 hover:text-blue-500'
                  }`}
                  href="https://snowycommander.link/?utm_source=profile-card"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View profile →
                </a>
              </div>

              {/* Profile Color Accent */}
              <div className="gravatar-hovercard__profile-color h-1" style={{ background: 'rgb(227, 234, 252)' }}></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contacts;
